import * as React from 'react';
// import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';


// let t;
let useSnackbarRef;
// 🎨 Nouveau design (tour 34) : les erreurs restent affichées jusqu'à leur fermeture
let persistErrors = false;
export const SnackbarUtilsConfigurator = ({ persistErrors: persist = false } = {}) => {
    useSnackbarRef = useSnackbar();
    persistErrors = !!persist;
    // const translation = useTranslation();
    // t = translation.t;
    return null;
};

const SnackbarCloseButton = ({ id }) => {
    const { closeSnackbar } = useSnackbar();
    return (
        <button className='border-0 bg-transparent text-white-50' onClick={() => closeSnackbar(id)}>
            {/* La nouvelle croix SVG */}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>
    );
};
const notistack = {
    apiError(error) {
        let text = null;
        if (error.status === 400 && error.data.title) {
            for (const key in error.data.errors) {
                for (const keys in error.data.errors[key]) {
                    this.error(error.data.errors[key][keys]);
                }
            }
        } else if (error.status === 405) {
            text = 'error.405'
        } else if (error.status === 500) {
            text = 'error.500'
        } else if ([404, 403, 401].includes(error.status)) {
            text = error.data.message;
        } else if (error.status === 400) {
            text = error.data.message;
        } else if (error.status === 307) {
            this.info(error.data.message);
        }
        if (text) {
            this.error(text);
        }
    },
    success(msg) {
        this.toast(msg, 'success');
    },
    warning(msg) {
        this.toast(msg, 'warning');
    },
    info(msg) {
        this.toast(msg, 'info');
    },
    error(msg) {
        this.toast(msg, 'error');
    },
    toast(msg, variant = 'default') {
        // Pas encore prêt (écran de chargement de la page) : message ignoré, sans faire échouer
        // l'appelant (ex. : la demande de cours renvoyée au chargement ne s'affichait pas)
        if (!useSnackbarRef) return;
        useSnackbarRef.enqueueSnackbar(msg, {
            variant,
            preventDuplicate: true,
            autoHideDuration: 4000, // 🟢 AJOUT : La notification disparaîtra après 4 secondes
            ...(persistErrors && variant === 'error' ? { persist: true } : {}),
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            },
            action: (key) => {
                return <SnackbarCloseButton id={key} />;
            }
        });
    },
};
export default notistack;